import React, { useState, useEffect, useCallback } from "react";
import { processService } from "../../services/process.service";
import { toast } from "sonner";
import { AdminProcessList as ProcessList } from "../management/AdminProcessList";
import { ProcessDetail } from "../management/ProcessDetail";
import { SindicatoViewsManager } from "../management/SindicatoViewsManager";
import { cn } from "../../lib/utils";

const { getProcessos } = processService;

const SECTIONS = [
  { key: "processos", label: "Processos" },
  { key: "sindicato", label: "Painel Sindicato" },
];

export function ManagementView() {
  const [section, setSection] = useState("processos");
  const [processos, setProcessos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProcesso, setSelectedProcesso] = useState(null);

  const fetchProcessos = useCallback(async () => {
    try {
      if (processos.length === 0) setLoading(true);
      const data = await getProcessos();
      setProcessos(data);

      if (selectedProcesso) {
        const updated = data.find(p => p.id === selectedProcesso.id);
        if (updated && JSON.stringify(updated) !== JSON.stringify(selectedProcesso)) {
          setSelectedProcesso(updated);
        }
      }
    } catch {
      toast.error("Erro ao carregar processos");
    } finally {
      setLoading(false);
    }
  }, [processos.length, selectedProcesso]);

  useEffect(() => {
    fetchProcessos();
  }, [fetchProcessos]);

  if (selectedProcesso) {
    return (
      <ProcessDetail
        processo={selectedProcesso}
        onBack={() => setSelectedProcesso(null)}
        onRefresh={fetchProcessos}
      />
    );
  }

  return (
    <div className="p-6 md:p-8 max-w-6xl mx-auto space-y-6">

      {/* Section tabs */}
      <div className="flex gap-1 bg-muted p-1 rounded-lg w-fit">
        {SECTIONS.map((s) => (
          <button
            key={s.key}
            onClick={() => setSection(s.key)}
            className={cn(
              "px-4 py-1.5 rounded-md text-sm font-medium transition-all",
              section === s.key
                ? "bg-card text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {s.label}
          </button>
        ))}
      </div>

      {section === "processos" && (
        <ProcessList
          processos={processos}
          loading={loading}
          onSelectProcess={setSelectedProcesso}
          onRefresh={fetchProcessos}
        />
      )}

      {section === "sindicato" && <SindicatoViewsManager />}
    </div>
  );
}
